import { FunctionComponent, createContext, ReactNode, useContext } from 'react'

import { useCart, getEmptyCart } from '@/hooks/cart'
import { CartContext } from './types'

interface Props {
  children: ReactNode
}
const CartCtx = createContext<CartContext>({
  loaded: false,
  state: getEmptyCart(),
  addItem: (item) => {
    throw new Error('addItem not implemented')
  },
  updateItem: (productId, quantity) => {
    throw new Error('updateItem not implemented')
  },
  removeItem: (productId) => {
    throw new Error('removeItem not implemented')
  },
  clearCart: () => {
    throw new Error('clearCart not implemented')
  }
})

export const useContextCart = (): CartContext => {
  return useContext(CartCtx)
}

export const CartProvider: FunctionComponent<Props> = ({ children }) => {
  const resp = useCart()
  return (
    <CartCtx.Provider value={resp}>
      {children}
    </CartCtx.Provider>
  )
}
